
(function () {
    const REPORTING_ENDPOINT = 'https://us-central1-vonvon-misc.cloudfunctions.net/js-stacktrace-reporter';
    const reported = [];

    window._report_error = function(exception) {
        if (!exception) {
            return;
        }
        // callback is called with an Array[StackFrame]
        const isReal = vv.getVvMetaData('stage') === 'real';
        if (isReal && reported.indexOf(exception.message) < 0) {
            reported.push(exception.message);
            StackTrace.fromError(exception).then((stackframes) => {
                const msg = {
                    message: exception.name + ": " + exception.message,
                    user_id: vv.getVvMetaData('admin_user_id'),
                    user_name: vv.getVvMetaData('admin_user_name')
                };
                StackTrace.report(stackframes, REPORTING_ENDPOINT, JSON.stringify(msg)).then(function() {
                    console.log("stacktrace reported.")
                });
            }).catch((errors) => {
                console.log('errors', errors)
            });
        }
    };

    window.onerror = function (msg, file, line, col, error) {
        window._report_error(error)
    };

})();
